import { makeStyles } from '@material-ui/core/styles';
import { variables } from '../../styles';

export const useStyles = makeStyles(() => ({
  dialogTitle: {
    margin: 0,
    paddingLeft: 3,
    paddingRight: 0,
    gap: 16,
    paddingTop: 16,
    paddingBottom: 16,
    color: variables.black,
  },
  title: {
    fontWeight: 600,
    fontSize: 18,
  },
  closeBtn: {
    color: variables.black,
  },
}));
